import React from "react"
import { useChargePersonStyle } from "./style"
import Tooltip from "@material-ui/core/Tooltip"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"

interface ComponentProps {
    title: any,
    text: string,
    openIndex: number,
    handleChangeOpenIndex: (index: number) => void,
    index: number,
}

const SubSelectList = (props: ComponentProps) => {
    const classes = useChargePersonStyle()
    const { title, text, openIndex, index, handleChangeOpenIndex } = props
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        handleChangeOpenIndex(index)
        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation()
    }
    return (
        <Tooltip
            open={index === openIndex}
            interactive
            placement="right-end"
            classes={{ tooltip: classes.tooltip }}
            title={title}
        >
            <div style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 20px",
            }} onClick={handleClick}>
                {text}
                {index === openIndex ? (<KeyboardArrowUpIcon />) : (<KeyboardArrowDownIcon/>)}
            </div>
        </Tooltip>
    )
}

export default SubSelectList
